import { useSelector } from 'react-redux'
import Header from './Header'
import { menuItems } from './config'

const Menu = () => {
  const { isLogin } = useSelector((state: any) => state.auth)

  return <Header menuItems={menuItems} isLogin={isLogin} />
}

export default Menu
